module.exports = __webpack_public_path__ + "static/invizi-logo-full-transparent-3e68c16dbc8ac7c182e336cebb25256a.png";